import { Component, OnInit } from "@angular/core";
import { KycService } from "@app/core/kyc.service";
import { routerTransition } from "../../router.animations";

import { QuestionControlService } from "@app/core/question-control.service";
import { QuestionService } from "@app/core/question.service";
import {
  renderFinancialData,
} from "@app/features/my-financial/my-financial";
import * as MyFinancialConstants from "@app/features/my-financial/constants";
import { Router } from "@angular/router";
import { NavTabService } from "@app/core/navTab.service";
import { onLifestyleError } from '@app/core/selectors'
import * as _ from "lodash";

@Component({
  selector: "app-my-lifestyle",
  templateUrl: "./my-lifestyle.component.html",
  animations: [routerTransition()],
  host: { "[@routerTransition]": "" }
})
export class MyLifestyleComponent implements OnInit {
  lifestyle = [];
  lifestyleData: any;
  smoked: any;
  choosenNeed: any;
  isError: boolean = true;
  isExclamationMark: boolean = true
  readonly INCOME_PROTECTION_KEY = MyFinancialConstants.INCOME_PROTECTION_KEY;
  readonly RETIREMENT_KEY = MyFinancialConstants.RETIREMENT_KEY;
  readonly SAVINGS_KEY = MyFinancialConstants.SAVINGS_KEY;
  readonly BIG_INVESTMENT_PLAN_KEY = MyFinancialConstants.BIG_INVESTMENT_PLAN_KEY;
  readonly HEALTH_KEY = MyFinancialConstants.HEALTH_KEY;

  constructor(
    private kycService: KycService,
    private questionService: QuestionService,
    private qcs: QuestionControlService,
    private router: Router,
    private navTabService: NavTabService
  ) { }

  ngOnInit() {
    //this.smoked = Number(this.kycService.kyc.profile.userProfile.smoked) === 1 ? 100 : 0;
    this.lifestyle = this.kycService.kyc.lifestyle.lifestyle;
    this.lifestyleData = this.getData('health');
  }


  getData(key: string) {
    let data: any
    this.kycService.kyc.lifestyle.lifestyle.forEach(lifestyle => {
      if (lifestyle.key === key) {
        this.choosenNeed = lifestyle;
        this.choosenNeed.iconColor = MyFinancialConstants.ICON_BLUE;
      }
    });
    data = renderFinancialData(
      this.choosenNeed.questionRaws,
      this.questionService,
      this.qcs
    );
    return data
  }

  goToNextPage() {
    this.kycService.kyc.lifestyle.lifestyle.forEach(lifestyle => {
      if (lifestyle.key === this.choosenNeed.key) {
        if (!lifestyle.displayData) {
          lifestyle.displayData = true;
        }
        lifestyle.questionRaws.forEach(question => {
          question.value = Number(this.lifestyleData.form.value[question.key]);
        });
      }
    });
    
    this.isError = onLifestyleError(this.kycService.kyc.lifestyle.lifestyle[0].questionRaws)
    if (this.isError) {
      this.kycService.kyc.lifestyle.completed = true;
      let tenant = this.kycService.getTenant();
      this.router.navigateByUrl("/" + tenant + "/journey/submit");
      this.navTabService.setActiveTab("submit");
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/features/my-lifestyle/my-lifestyle.component.ts